import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core';
import ourApproach from '../../images/ourApproach.jpg';
import { COLOR_CORAL, COLOR_RED_VISITED } from '../../utils/constants';

const useStyles = makeStyles({
  container: {
    justifyContent: 'space-between',
    marginTop: 80,
    marginBottom: 40,
    '@media (max-width:600px)': {
      flexDirection: 'column-reverse',
      marginTop: 40,
      marginBottom: 0,
    },
  },
  imageGrid: {
    padding: '0px 0px 0px 100px',
    '@media (max-width:900px)': {
      padding: '0px 0px 40px 50px',
    },
    '@media (max-width:600px)': {
      padding: '0px 0px 20px 0px',
    },
  },
  textGrid: {
    padding: '0px 0px 0px 160px',
    maxWidth: 720,
    '@media (max-width:1024px)': {
      padding: '20px 0px 40px 100px',
    },
    '@media (max-width:900px)': {
      padding: '20px 0px 40px 50px',
    },
    '@media (max-width:600px)': {
      padding: '20px 20px 20px 20px',
    },
  },
  listContainer: {
    maxWidth: '80%',
    paddingBottom: '32px',
  },
  link: {
    margin: '0 0 8px',
    display: 'block',
    color: COLOR_CORAL,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
      textDecorationColor: COLOR_CORAL,
    },
    '&:visited': {
      color: COLOR_RED_VISITED,
    },
  },
});
const SustainabilityPage = () => {
  const classes = useStyles();
  return (
    <Grid container className={classes.container}>
      <Grid item sm={6} className={classes.textGrid}>
        <h3 style={{ marginTop: 0 }}>Our approach to sustainability</h3>
        <p style={{ paddingRight: 32, maxWidth: 600 }}>
          The Vow group is passionate about preventing pollution, which directly
          connects to the group’s purpose of mitigating climate change. From the
          start, sustainability has been an integral part of the business
          activities. Vow’s solutions purify wastewater and convert biomass and
          waste into valuable resources, generating CO2 neutral energy and
          biocarbon that decarbonise industrial processes for customers in
          cruise, aquaculture and a wide range of landbased industries and
          utilities. These solutions emerge from the group’s mission to maximise
          environmental sustainability impact, creating long-term value for
          shareholders, the environment, and society.
        </p>
        <p style={{ paddingRight: 32, maxWidth: 600, marginBottom: 0 }}>
          In the daily work to pursue the group’s purpose and deliver on the
          group’s mission, Vow is directed by a set of core values:
        </p>
        <ul className={classes.listContainer}>
          <li>
            We are passionate about preventing pollution, giving waste value,
            and mitigating climate change.
          </li>
          <li>
            We have a proactive approach and are responsible in what we do.
          </li>
          <li>
            We strive to always be innovative and deliver the best solution.
          </li>
        </ul>
        <h3 style={{ marginTop: 0 }}>Sustainability Report 2020</h3>
        <p style={{ paddingRight: 32, maxWidth: 600 }}>
          Vow has released its first Sustainability Report showing important
          progress in key areas. The report highlights and provides insight into
          the group’s performance and priorities in environmental, social and
          governance (ESG) factors.
        </p>
        <a
          href="https://firebasestorage.googleapis.com/v0/b/vow-asa.appspot.com/o/sustainability%2FSustainability%20Report%202020%20for%20web.pdf?alt=media&token=68399604-a031-4c56-818f-4c1d028fa0db"
          target="_blank"
          rel="noopener noreferrer"
          className={classes.link}
        >
          Sustainability Report 2020 for web - PDF
        </a>
      </Grid>
      <Grid item sm={6} className={classes.imageGrid}>
        <img src={ourApproach} alt="vow sustainability" />
      </Grid>
    </Grid>
  );
};

export default SustainabilityPage;
